import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ProductList } from '../components/ProductList';
import { categoryFromSlug } from '../categories';

interface CategoryPageProps {
  token: string | null;
  userId: number | null;
  isVerified: boolean;
  onLogin: (accessToken: string, refreshToken: string) => void;
  setError: (e: string) => void;
}

export const CategoryPage: React.FC<CategoryPageProps> = ({
  token,
  userId,
  isVerified,
  onLogin,
  setError,
}) => {
  const { categorySlug } = useParams<{ categorySlug: string }>();
  const category = categoryFromSlug(categorySlug);

  if (category === null) {
    return <Navigate to="/categories" replace />;
  }

  return (
    <ProductList
      category={category}
      token={token}
      userId={userId}
      isVerified={isVerified}
      onLogin={onLogin}
      setError={setError}
    />
  );
};
